import * as THREE from "three"
import gsap from "gsap"
import Experience from "./Experience.js";
import { OrbitControls } from "three/examples/jsm/Addons.js";
import { isTouchOnlyDevice } from "./Utils/InputDevice.js";
export default class Camera {

    constructor() {
        this.experience = new Experience()
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.canvas = this.experience.canvas
        this.isZoomedIn = false
        this.setInstance()
        // this.setOrbitControls()

    }

    setInstance() {
        const { position, lookAt } = this.isZoomedIn
            ? this.getConsoleView()
            : { position: { x: 3.5, y: 3, z: 5 }, lookAt: { x: 0, y: 0, z: 0 } }

        this.instance = new THREE.PerspectiveCamera(35, this.sizes.width / this.sizes.height, 0.1, 100)
        this.lookAtTarget = new THREE.Vector3(lookAt.x, lookAt.y, lookAt.z)
        this.instance.position.set(position.x, position.y, position.z)
        this.instance.lookAt(this.lookAtTarget)

        this.scene.add(this.instance)

    }

    getConsoleView() {
        const isMobile = isTouchOnlyDevice()
        const position = isMobile
            ? { x: 0, y: 0.3, z: 2.5 }
            : { x: 0, y: 0.61, z: 1.3 }
        const lookAt = isMobile
            ? { x: 0, y: 0.3, z: 0 }
            : { x: 0, y: 0.61, z: 0 }

        return { position, lookAt }
    }

    animateView(targetPosition, targetLookAt) {
        gsap.killTweensOf(this.instance.position)
        gsap.killTweensOf(this.lookAtTarget)

        gsap.to(this.instance.position, {
            ...targetPosition,
            duration: 1,
            ease: "power2.inOut"
        })

        gsap.to(this.lookAtTarget, {
            ...targetLookAt,
            duration: 1,
            ease: "power2.inOut",
            onUpdate: () => {
                this.instance.lookAt(this.lookAtTarget)
            }
        })
    }

    setZoomState(isZoomedIn) {
        if (this.isZoomedIn === isZoomedIn) {
            return
        }

        this.isZoomedIn = isZoomedIn
        window.dispatchEvent(new CustomEvent("camera-zoom-change", {
            detail: { isZoomedIn }
        }))
    }

    zoomToConsole() {
        this.setZoomState(true)
        const { position, lookAt } = this.getConsoleView()
        this.animateView(position, lookAt)
    }

    resetZoom() {
        this.setZoomState(false)
        this.animateView(
            { x: 3.5, y: 3, z: 5 },
            { x: 0, y: 0, z: 0 }
        )
    }

    setOrbitControls() {
        this.controls = new OrbitControls(this.instance, this.canvas)
        this.controls.enableDamping = true
        this.controls.target = new THREE.Vector3(0, 0.3, 0)
    }

    resize() {
        this.instance.aspect = this.sizes.width / this.sizes.height
        this.instance.updateProjectionMatrix()
    }

    update() {
        // this.controls.update()
    }
}
